import script from "./FoundInSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundInSearch.vue?vue&type=script&setup=true&lang=js"

import "./FoundInSearch.vue?vue&type=style&index=0&id=2637ba00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2637ba00"]])

export default __exports__